import { render, staticRenderFns } from "./GroupTabPet.vue?vue&type=template&id=032dabe2&scoped=true&"
import script from "./GroupTabPet.vue?vue&type=script&lang=js&"
export * from "./GroupTabPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032dabe2",
  null
  
)

export default component.exports